import DepressableButton from '../library/DepressableButton';

export default class MenuButton extends DepressableButton {
  constructor(game, up, down, onClick) {
    const buttonX = game.scale.width - 150;
    const buttonY = 60;
    const buttonScale = .28;

    super(game, buttonX, buttonY, up, down, onClick);

    this.game = game;

    this.button.setScale(buttonScale);
  }
}